import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, usePublicationDetailDispatch } from "./publication-detail-context";

export const usePublicationDetailController = () => {
    const dispatch = usePublicationDetailDispatch();

    async function loadDetail(id: number) {
        try {
            dispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });

            const result = await PortalAppService.requestPublicationDetail(id);

            dispatch({
                type: ACTION_TYPES.loadingDetail,
                payload: result,
            });
        } catch (error) {
            console.error('Erro ao carregar detalhes da publicação:', error);
            dispatch({
                type: ACTION_TYPES.setError,
                payload: 'Erro ao carregar os detalhes da publicação',
            });
        }
    }

    function clearData() {
        dispatch({
            type: ACTION_TYPES.clearData,
        });
    }

    return {
        loadDetail,
        clearData
    };
}
